import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { CommonService } from 'src/app/shared/common.service';

@Component({
  selector: 'app-vertual',
  templateUrl: './vertual.component.html',
  styleUrls: ['./vertual.component.scss']
})
export class VertualComponent {
  @Output() registerClicked = new EventEmitter<any>();

  days = 0;
  hours = 0;
  minutes = 0;
  seconds = 0;

  countdownSub!: Subscription;
  targetDate!: Date;
  nextSession: any;

  constructor(private commonService: CommonService, private router: Router) {}

  ngOnInit() {
    this.loadNextLiveSession();
  }

  // ✅ Load nearest upcoming session
  loadNextLiveSession() {
    this.commonService.getFreeEventSessions().subscribe({
      next: (res: any) => {
        if (res.status === 1 && res.data.length > 0) {
          const allSessions: any[] = [];

          res.data.forEach((event: any) => {
            event.sessions?.forEach((s: any) => {
              const dateTime = new Date(`${s.date}T${s.startTime}`);
              if (dateTime > new Date()) {
                allSessions.push({
                  ...s,
                  eventId: event._id,
                  eventTitle: event.title,
                  eventDescription: event.description,
                  dateTime
                });
              }
            });
          });

          allSessions.sort((a, b) => a.dateTime - b.dateTime);

          if (allSessions.length > 0) {
            this.nextSession = allSessions[0];
            this.targetDate = this.nextSession.dateTime;
            this.startCountdown();
          }
        }
      },
      error: () => console.error('Failed to load sessions.')
    });
  }

  // ✅ Countdown logic
  startCountdown() {
    this.updateCountdown();
    this.countdownSub = interval(1000).subscribe(() => this.updateCountdown());
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.targetDate?.getTime() - now;

    if (distance <= 0) {
      this.days = this.hours = this.minutes = this.seconds = 0;
      if (this.countdownSub) this.countdownSub.unsubscribe();
      return;
    }

    this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
    this.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
  }

  ngOnDestroy() {
    if (this.countdownSub) this.countdownSub.unsubscribe();
  }

  // ✅ Emit event to parent for registration popup
 onSecureSpot() {
  if (this.nextSession) {
    console.log('Vertual session emitted:', this.nextSession);

    this.registerClicked.emit({
      eventId: this.nextSession.eventId,
      sessionId: this.nextSession.id,   // ✅ FIX HERE
      title: this.nextSession.eventTitle,
      description: this.nextSession.eventDescription,
      date: this.nextSession.date,
      startTime: this.nextSession.startTime,
      timezone: this.nextSession.timezone
    });
  }
}


 scrollToTop(): void {
    (document.scrollingElement || document.documentElement || document.body).scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  goToLiveSession() {
    // Pass a state flag to indicate scroll after navigation
    this.router.navigate(['/live-session'], { state: { scrollToLiveSession: true } });
  }
}
